import request from '@/libs/request'

//投入品库存 列表
export function plantThingsStockListApi (data) {
  return request({
    url: `plant/plantThingsStock`,
    method: 'get',
    params: data
  })
}

//投入品库存 详情
export function plantThingsStockInfoApi (id) {
  return request({
    url: `plant/plantThingsStock/` + id,
    method: 'get'
  })
}

//投入品库存 编辑/添加
export function plantThingsStockSaveApi (data) {
  return request({
    url: `plant/plantThingsStock`,
    method: 'post',
    data: data
  })
}

//投入品库存 删除
export function plantThingsStockDelApi (id) {
  return request({
    url: `plant/plantThingsStock/` + id,
    method: 'delete'
  })
}

//投入品库存 所有
export function plantThingsStockAllApi (data = {}) {
  return request({
    url: `plant/plantThingsStockApi/all`,
    method: 'get',
    params: data
  })
}

